var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.items.length > 0
    ? _c("div", { staticClass: "dropdown" }, [
        _vm.variant == "standard"
          ? _c(
              "button",
              {
                staticClass:
                  "btn border-color--primary-1 dropdown-toggle dropdown-size",
                attrs: {
                  id: "dropdownMenuButton",
                  "aria-expanded": "false",
                  "aria-haspopup": "true",
                  "data-toggle": "dropdown",
                  type: "button"
                }
              },
              [
                _vm.icon
                  ? _c("em", {
                      key: _vm.icon,
                      staticClass: "mr-2",
                      class: _vm.icon
                    })
                  : _vm._e(),
                _vm._v(" " + _vm._s(_vm.title) + " ")
              ]
            )
          : _vm.variant == "rounded-dark"
          ? _c(
              "button",
              {
                staticClass:
                  "btn border-none px-4 bg-secondary-16 text-white variant-rounded-dark rounded-pill",
                attrs: {
                  "aria-expanded": "false",
                  "aria-haspopup": "true",
                  "data-toggle": "dropdown",
                  type: "button"
                }
              },
              [
                _vm.icon
                  ? _c("em", {
                      key: _vm.icon,
                      staticClass: "mr-2",
                      class: _vm.icon
                    })
                  : _vm._e(),
                _vm._v(" " + _vm._s(_vm.title) + " ")
              ]
            )
          : _vm._e(),
        _c(
          "div",
          {
            staticClass: "dropdown-menu dropdown-menu-right",
            attrs: { "aria-labelledby": "dropdownMenuButton" }
          },
          _vm._l(_vm.visibleItems, function(item) {
            return _c(
              "div",
              { key: item.label },
              [
                _c(
                  "div",
                  {
                    staticClass: "dropdown-item py-2",
                    class: `${item.border && `border-${item.border}`} ${
                      item.class
                    }`,
                    on: {
                      click: function($event) {
                        return _vm.eventHandler(item.click)
                      }
                    }
                  },
                  [
                    item.icon
                      ? _c("em", {
                          key: item.icon + item.label,
                          staticClass: "mr-2",
                          class: item.icon
                        })
                      : _vm._e(),
                    _vm._v(" " + _vm._s(item.label) + " ")
                  ]
                ),
                _vm._l(item.children, function(child) {
                  return _c(
                    "div",
                    {
                      key: child.label,
                      staticClass: "dropdown-item py-2 pl-5",
                      class: `${child.border && `border-${child.border}`} ${
                        child.class
                      }`,
                      on: {
                        click: function($event) {
                          return _vm.eventHandler(child.click)
                        }
                      }
                    },
                    [
                      child.icon
                        ? _c("em", {
                            key: child.icon + child.label,
                            staticClass: "mr-2",
                            class: child.icon
                          })
                        : _vm._e(),
                      _vm._v(" " + _vm._s(child.label) + " ")
                    ]
                  )
                })
              ],
              2
            )
          }),
          0
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }